import type { Category } from "@/types";

/**
 * Single definition of "which category owns this item offer". `itemOfferId` is
 * a string[] on Category, so this is an array-membership check. Centralised so
 * the mapping rule lives in one place instead of three copy-pasted predicates.
 */
export function findCategoryForOffer(
  categories: Category[],
  offerId: string,
): Category | undefined {
  return categories.find((category) => category.itemOfferId?.includes(offerId));
}
